export default "__VITE_ASSET__6$2dMCKT__"